import { Avatar } from "antd";
import { avatarInitial, getAvatarColor } from "../utils/avatarColors";

export interface MemberAvatarProps {
  id: number | string | null | undefined;
  name: string;
  image?: string | null;
  // Matches AntD's Avatar size (px). Default 32 ≈ presenter's `md` (28px)
  // bumped a touch for the team table density. Pass an explicit value at
  // callsites that need a different size.
  size?: number;
}

// React port of `aha-avatar` (stpancras-storybook-app/src/components/UI/Avatar.vue):
// when `image` is set, render it; otherwise a coloured circle with the first
// grapheme of `name`. The colour is seeded by `id` so a given member keeps
// the same colour everywhere — parity with the presenter team page.
// See AHA-42835.
export function MemberAvatar({ id, name, image, size = 32 }: MemberAvatarProps) {
  // `flexShrink: 0` is load-bearing — when this sits in a flex row next to a
  // long name with `min-width: 0` on the text wrapper (the only way to let
  // the name truncate), the avatar would otherwise be allowed to shrink
  // horizontally while its height stays fixed, producing a distorted oval
  // on narrow viewports. Mirrors `class="flex-shrink-0"` on the presenter's
  // `aha-avatar`. See AHA-42839.
  if (image) {
    return <Avatar src={image} size={size} alt={name} style={{ flexShrink: 0 }} />;
  }
  return (
    <Avatar
      size={size}
      style={{ flexShrink: 0, backgroundColor: getAvatarColor(id, name), color: "#fff" }}
    >
      {avatarInitial(name)}
    </Avatar>
  );
}
